import API_Root from "./API_Root";

export const createFullURLFromBase = (baseURL) => {
    let API = API_Root === "https://api-woyera.com/" ? "https://api.apispreadsheets.com/" : API_Root;

    return API + baseURL
}
